import { Check } from 'lucide-react';
import { TournamentCategory } from 'modules/jogador/tournaments/types';
import { cn } from 'shared/utils/cn';

interface CategoryOptionProps {
  category: TournamentCategory;
  isSelected: boolean;
  onSelect: (categoryId: string) => void;
}

export function CategoryOption({ category, isSelected, onSelect }: CategoryOptionProps) {
  const isFull = category.status === 'full';

  return (
    <button
      type="button"
      disabled={isFull}
      onClick={() => onSelect(category.id)}
      className={cn(
        'flex w-full items-center justify-between rounded-xl border p-4 text-left transition-colors disabled:cursor-not-allowed',
        isSelected ? 'border-primary bg-accent-soft/40' : 'border-border/70 hover:border-primary'
      )}
    >
      <div>
        <p className="font-medium text-ink">{category.name}</p>
        <p className={cn('text-sm', isFull ? 'text-warning' : 'text-ink-secondary')}>
          {category.spotsLabel}
        </p>
      </div>

      {isSelected && (
        <span className="flex h-6 w-6 items-center justify-center rounded-full bg-primary text-surface">
          <Check className="h-3.5 w-3.5" strokeWidth={2.5} aria-hidden="true" />
        </span>
      )}
    </button>
  );
}
